import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { EMOJI_TYPES } from 'client/types';

import { RootState } from '../../..';
import { PB_CHANNELS } from '../../constants';
import { getErrorText } from '../helpers';

export const getReactionsMessagesCount = createAsyncThunk<
  Pubnub.MessageCountsResponse['channels'],
  { roomId: string },
  { rejectValue: string }
>('pubnub/getReactionsMessagesCount', async (data, { rejectWithValue, getState }) => {
  try {
    const pubnubReducer = (getState() as RootState).pubnub;
    const { roomId } = data;
    const timeToken = `${946677600000 * 10000}`; // new Date('01.01.2000') - 946677600000
    const channels = [
      `${roomId}.${PB_CHANNELS.REACTIONS}.${EMOJI_TYPES.HEART}`,
      `${roomId}.${PB_CHANNELS.REACTIONS}.${EMOJI_TYPES.ANGRY}`,
      `${roomId}.${PB_CHANNELS.REACTIONS}.${EMOJI_TYPES.SMILE}`,
      `${roomId}.${PB_CHANNELS.REACTIONS}.${EMOJI_TYPES.WONDER}`,
      `${roomId}.${PB_CHANNELS.REACTIONS}.${EMOJI_TYPES.CRY}`,
      `${roomId}.${PB_CHANNELS.REACTIONS}.${EMOJI_TYPES.LIKE}`,
    ];

    if (pubnubReducer.pubnub) {
      const result = await pubnubReducer.pubnub.messageCounts({
        channels,
        channelTimetokens: Array.from({ length: channels.length }).map(() => timeToken),
      });

      return result.channels;
    } else {
      throw new Error('PubnubInstanceIsNull');
    }
  } catch (e) {
    return rejectWithValue(getErrorText(e as Error));
  }
});
